import React, { useRef } from 'react'
import'./home.css'
import Slideshow from './Slideshow/slideshow'
import {BsFacebook, BsDiscord} from 'react-icons/bs'
import {RiInstagramFill} from 'react-icons/ri'
import { Link } from 'react-router-dom'

const Home = () => {
  const ref = useRef(null);

  const handleClick = () => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className='home__container'>
      <Slideshow id='slideshow'/>
      {/* <p className='fade-in'>Women in Computing <br/>@ UW</p> */}
      <div id='get-involved' onClick={handleClick}>
        <p>how to join</p>
      </div>
      <div className='home-content'>
        <p><strong className='wic-title'>Women in Computing</strong>at the <strong>University of Washington</strong> is a group of students in the Paul G. Allen School (of all genders and orientations) dedicated to cultivating a strong, supportive community of women within the Allen School.</p>
        <p> We strive to help members succeed academically, socially and professionally, and we believe in demonstrating the importance and necessity of diversity in computing.</p>
      </div>

      <div className='actions' ref={ref}>
      <div className='action-description'>
          <p ><strong>Not a  WiC member?</strong></p>
          <p>Join <a href='http://tinyurl.com/wic-membership-form' target='_blank' class='footerLink'>here</a> and sign up for 
          our <a href='https://mailman.cs.washington.edu/mailman/listinfo/wic' target='_blank'  class='footerLink'>mailing list</a> to 
          get updates on events and opportunities! Follow us on our Facebook and Instagram page! Join our Discord server!</p>
        </div>
        <br></br>
        <div className='socials'>
          <a id='insta' href='https://www.instagram.com/uw.wic/' target='_blank' rel="noreferrer"><RiInstagramFill/></a>
          <a id='fbook' href='https://www.facebook.com/uwwic' target='_blank' rel="noreferrer"><BsFacebook/></a>
            <a id='discord' href='https://discord.gg/Zp4GVB7ddq' target='_blank' rel="noreferrer"><BsDiscord/></a>
        </div>
        <div className='wicEmail'>
          <a href="mailto:wic-officers@cs.washington.edu" class='footerLink'>wic-officers@cs.washington.edu</a>
        </div>

        <Link to="/involved">
          <button class="wic-action-button">FAQs + List of Links</button>
        </Link>
      </div>

      <div className='home__container'>
        <div className='home-content'>
        <p><strong className='wic-title'>Upcoming Events</strong></p>
        <p>From career panels to fun potlucks, WiC offers several events helping you get more involved in our community! Check out our dynamic calendar for regular updates on upcoming events.</p>

        <Link to="/event">
          <button class="wic-events-button">See WiC Events Calendar</button>
        </Link>
    
        </div>
      </div>

      <div className="divider"></div>
      <div className='home__container'>
        <div className='home-content'>
        <p><strong className='wic-title'>WiC Blog</strong></p>
        <p>Get a taste of past WiC events and relive memories through our WiC blog!</p>
        <Link to="/blog">
          <button class="wic-events-button">See WiC Blog</button>
        </Link>
        </div>
      </div>

      <div className="divider"></div>
      <div className='home__container'>
        <div className='home-content'>
        <p><strong className='wic-title'>WiC Resources</strong></p>
        <p>Looking for Resources on Academics, Community, Career, and Mental Health? Check out our Resources page curated by our WiC leadership team!</p>
        <Link to="/resources">
          <button class="wic-events-button">See WiC Resources Page</button>
        </Link>
        </div>
      </div>
    </div>
  )
}

export default Home
